module.exports = __webpack_public_path__ + "img/terracenew_box11.992bf1bf.jpg";